var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookCircleLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5610",
    d: "M0 0h40v40H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5611",
    d: "M21.25 33.392a14.01 14.01 0 1 0-3.5 0V23h-3.5v-3.5h3.5v-2.895c0-2.34.245-3.188.7-4.044a4.771 4.771 0 0 1 1.988-1.986 6.935 6.935 0 0 1 2.952-.667 11.3 11.3 0 0 1 2.236.14v3.325h-.876a6.346 6.346 0 0 0-2.664.287 1.272 1.272 0 0 0-.55.55c-.21.4-.287.788-.287 2.394v2.9h4.375L24.75 23h-3.5zM19.5 37A17.5 17.5 0 1 1 37 19.5 17.5 17.5 0 0 1 19.5 37z",
    transform: "translate(.5 .5)",
    style: {
      fill: "#212121"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookCircleLine);
export default __webpack_public_path__ + "static/media/facebook-circle-line.5027741ca68a5e8bcaba6e46479e6f9f.svg";
export { ForwardRef as ReactComponent };